
export function CurrencyData() {
  return {
  	"USD":"$",
  	"INR":"₹"
  } 
}